export default "__VITE_ASSET__DleQ3Hic__"